module.exports = __webpack_public_path__ + "img/feed-supplement.3adb8b10.svg";